import React from "react";
import {
	PageTemplateProps,
	PageTemplate,
} from "src/components/common/PageTemplate";
import { NumberSequencesDataGrid } from "src/components/views/erp/common/numberSequences/NumberSequencesDataGrid";

export interface NumberSequencesPageProps extends PageTemplateProps {}

export const NumberSequencesPage = React.memo(
	(props: NumberSequencesPageProps) => {
		return (
			<PageTemplate {...props}>
				<NumberSequencesDataGrid />
			</PageTemplate>
		);
	},
);
